module.exports = __webpack_public_path__ + "img/bfgnyl.cbf760f8.svg";